const ameMenu = [
  {
    System: 'AME',
    isActive: true,
    menu: [
      { is_header: true, title: 'ApprovalsManagement', isActive: true },
       
      {
        path: '/AME/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      // {
      //   path: "/NTX",
      //   icon: "bi bi-code-square",
      //   title: "RequestForms",
      //   children: [
      //     {
      //       path: "NTX/Forms",
      //       title: "RequestForms",
      //       isActive: HasPermission('AmeViewListApplicationForms'),
      //     },
      //   ],
      // },

      {
        path: '/AME/Forms',
        icon: 'fas fa-file-alt',
        title: 'RequestForms',
        isActive: true,
        permission: 'AmeViewListApplicationForms'
      },

      // { is_header: true, title: "RequestSettings" , isActive:true},

      // {
      //   path: "Ame/Conditions",
      //   icon: "fas fa-tasks",
      //   title: "الشروط",
      //   //  isActive: HasPermission('AmeOrderSettingsList'),
      //    isActive: true,
      // },
      // {
      //   path: "Ame/Rules",
      //   icon: "fas fa-gavel",
      //   title: "القواعد",
      //   //  isActive: HasPermission('AmeOrderSettingsList'),
      //    isActive: true,
      // },

      {
        path: '/AME/RequestSetting',
        icon: 'fas fa-cogs',
        title: 'RequestSettings',
        permission: 'AmeOrderSettingsList',
        isActive: true
      },
      {
        path: '/AME/ApprovalGroup',
        icon: 'fas fa-users',
        title: 'ApprovalGroup',
        permission: 'AmeListApprovalGroups',
        isActive: true
      },
      {
        path: '/AME/FollowRequests',
        icon: 'fas fa-clipboard-list',
        title: 'FollowRequests',
        permission: 'AmeViewListFollowRequests',
        isActive: true
      },
      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/AME/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/AME/Dashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
      }
      // { is_header: true, title: 'التوقيـع', isActive: true },

      // {
      //   path: 'Ame/NtxTest',
      //   icon: 'bi-pencil',
      //   title: 'Ntx Test',
      //   isActive: true,
      // },

      // {
      //   path: "",
      //   icon: "bi bi-clipboard-data-fill",
      //   title: "Reports",
      //   isActive: true,
      // },

      // {
      //   path: "",
      //   icon: "bi bi-cpu",
      //   title: "لوحة البيانات",
      //   isActive: true,
      // },
    ]
  }
];

export default ameMenu;
